// PROTOTYPE-ONLY — remove before production
import React from "react";
import { AlertTriangle } from "lucide-react";

/**
 * SAMPLE DATA banner used on every internal dashboard so no viewer can mistake
 * the mock numbers for real traction. Persistent, non-dismissible.
 */
export default function SampleDataBanner({ compact = false, className = "" }) {
  return (
    <div
      data-testid="sample-data-banner"
      className={`sb-card p-3 flex items-center gap-2.5 border-[#EF4444]/40 ${className}`}
      style={{ background: "rgba(239,68,68,.06)" }}
    >
      <AlertTriangle size={14} className="text-[#EF4444] shrink-0" />
      <span className="text-[11.5px] font-bold uppercase tracking-widest text-[#EF4444]">
        Sample Data — Prototype Only
      </span>
      {!compact && (
        <span className="hidden sm:inline text-[11.5px] text-[#A1A1AA]">
          · figures are illustrative and must never be shown publicly.
        </span>
      )}
    </div>
  );
}
